import React, { useState, useEffect } from 'react'
import {
  Document,
  Page,
  View,
  Text,
  Font,
  StyleSheet,
  Image,
  PDFDownloadLink,
} from '@react-pdf/renderer'
import { Roboto } from '../../../fonts'
import { getLogoUrl } from '../../../api/Logo'
import { dateNowProtocol } from '../../../api/formatDate'
import Win1Icon from '../../../images/win_1.png'
import Win2Icon from '../../../images/win_2.png'
import Win3Icon from '../../../images/win_3.png'
import { useParams } from 'react-router-dom'
import {
  deleteData,
  updateData,
  getData,
  addData,
  upsertDataTournaments,
} from '../../../api/indexedDBHandler'

Font.register({
  family: 'Roboto',
  fonts: [
    { src: Roboto.normal, fontWeight: 'normal' },
    { src: Roboto.bold, fontWeight: 'bold' },
  ],
})

const styles = StyleSheet.create({
  page: {
    flexDirection: 'column',
    padding: 20,
    fontFamily: 'Roboto',
  },

  header: {
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 15,
    gap: 20,
  },
  logo: {
    width: 100,
    height: 'auto',
  },
  logoContainer: {
    flexDirection: 'row',
    justifyContent: 'center', // Выравнивание по центру
    alignItems: 'center', // Вертикальное выравнивание
    flexWrap: 'wrap', // Перенос на новую строку при необходимости
    gap: 15, // Расстояние между логотипами
    marginTop: 20, // Отступ сверху
    marginBottom: 10, // Отступ снизу
  },
  logoSmall: {
    // width: 40,
    // height: 'auto',
    // maxHeight: 40, // Ограничение по высоте
    height: 40,
    width: 'auto',
  },
  headerTextContainer: {
    flexGrow: 1,
    justifyContent: 'center',
  },
  headerText: {
    fontSize: 10,
    marginVertical: 2,
    lineHeight: 1.3,
    flexGrow: 1,
    width: '75%',
    flexWrap: 'wrap',
  },
  title: {
    width: '75%',
    textAlign: 'center',
    fontSize: 14,
    marginBottom: 10,
    fontWeight: 'bold',
    textTransform: 'uppercase',
  },
  description: {
    textAlign: 'center',
    fontSize: 10,
    lineHeight: 1.3,
    marginBottom: 10,
    flexWrap: 'wrap',
  },
  tableHeader: {
    backgroundColor: '#f2f2f2',
  },
  tableColHeader: {
    padding: 2,
    fontSize: 7,

    textAlign: 'center',
  },
  tableCol: {
    borderStyle: 'solid',
    borderWidth: 0.4,
    borderColor: '#000',
    padding: 2,
    fontSize: 8,
    textAlign: 'center',
  },
})

// settotalFishCount(totalFishCount)
// settotalWeight(totalWeight)
// setaverageFishWeight(averageFishWeight)
// setbiggestFish(biggestFish)
const TournamentProtocolPDF = ({
  allLogo,
  mainLogo,
  data,
  administrator,
  tournament,
  date,
  totalFishCount,
  totalWeight,
  averageFishWeight,
  biggestFish,
  isfinish,
}) => (
  <Document style={{ margin: 40 }}>
    <Page size="A4" style={{ padding: 20, fontFamily: 'Roboto' }}>
      {/* Заголовок */}
      <View style={styles.header}>
        {mainLogo && <Image src={mainLogo} style={styles.logo} />}
        <View style={styles.headerTextContainer}>
          <Text style={styles.title}>{tournament.tournament_name}</Text>
          <Text style={styles.headerText}>
            Водоём:{' '}
            <Text style={{ fontWeight: 'bold' }}> {tournament.water_body}</Text>
          </Text>
          <Text style={styles.headerText}>
            Дата проведения:{' '}
            <Text style={{ fontWeight: 'bold' }}>
              {tournament.start_date} - {tournament.end_date}
            </Text>
          </Text>
          <Text style={styles.headerText}>
            Дата составления: <Text style={{ fontWeight: 'bold' }}>{date}</Text>
          </Text>
        </View>
      </View>

      <Text
        style={{
          fontSize: 12,
          fontWeight: 'bold',
          textAlign: 'center',
          marginBottom: 10,
        }}
      >
        ИТОГОВЫЙ ПРОТОКОЛ
        {/* ИТОГОВЫЙ ПРОТОКОЛ*/}{' '}
        {/*    ИНФОРМАЦИОННЫЙ ПРОТОКОЛ ПРОМЕЖУТОЧНЫХ РЕЗУЛЬТАТОВ*/}
      </Text>
      <Text style={{ fontSize: 10, textAlign: 'center', marginBottom: 10 }}>
        Ловля карпа – парные соревнования (мужчины, женщины), код дисциплины
        0920151811Л
      </Text>
      <View>
        <View
          style={{
            width: '100%',
            borderStyle: 'solid',
            borderWidth: 0.3,
            borderColor: '#000',
            backgroundColor: '#f2f2f2',
          }}
        >
          <View style={{ flexDirection: 'row', alignItems: 'center' }}>
            <Text style={[styles.tableColHeader, { width: '6%' }]}>Место</Text>
            <Text style={[styles.tableColHeader, { width: '6%' }]}>
              Место в группе
            </Text>
            <Text
              style={[
                styles.tableColHeader,
                { width: '20%', textAlign: 'left' },
              ]}
            >
              Команда
            </Text>
            <Text
              style={[
                styles.tableColHeader,
                { width: '27%', textAlign: 'left' },
              ]}
            >
              Состав (Ф.И.О./разряд)
            </Text>
            <Text style={[styles.tableColHeader, { width: '5%' }]}>Группа</Text>
            <Text style={[styles.tableColHeader, { width: '5%' }]}>Сектор</Text>
            <Text style={[styles.tableColHeader, { width: '5%' }]}>Кол-во</Text>
            <Text style={[styles.tableColHeader, { width: '7%' }]}>Вес</Text>
            <Text style={[styles.tableColHeader, { width: '6%' }]}>
              Крупная рыба
            </Text>
            <Text style={[styles.tableColHeader, { width: '6%' }]}>
              Средний вес
            </Text>
            <Text style={[styles.tableColHeader, { width: '7%' }]}>
              До лидера
            </Text>
          </View>
        </View>
      </View>
      {data.map((item, index) => (
        <View
          key={index}
          style={{ borderWidth: 0.3, borderColor: '#000', marginBottom: 0 }}
        >
          <View
            style={{
              flexDirection: 'row',
              alignItems: 'center',
              backgroundColor: item.overallRank < 4 ? '#8FBC8F' : '#fff',
            }}
          >
            {isfinish && item.overallRank === 1 && (
              <View
                style={{
                  width: '6%',
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  paddingVertical: 2, // дополнительный отступ сверху/снизу
                }}
              >
                <Image src={Win1Icon} style={{ width: 13, height: 13 }} />
              </View>
            )}
            {isfinish && item.overallRank === 2 && (
              <View
                style={{
                  width: '6%',
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  paddingVertical: 2, // дополнительный отступ сверху/снизу
                }}
              >
                <Image src={Win2Icon} style={{ width: 13, height: 13 }} />{' '}
              </View>
            )}
            {isfinish && item.overallRank === 3 && (
              <View
                style={{
                  width: '6%',
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  paddingVertical: 2, // дополнительный отступ сверху/снизу
                }}
              >
                <Image src={Win3Icon} style={{ width: 13, height: 13 }} />{' '}
              </View>
            )}
            {!isfinish && index < 3 && (
              <Text
                style={{
                  width: '6%',
                  textAlign: 'center',
                  fontSize: 8,
                  fontWeight: 'bold',
                  padding: 2,
                }}
              >
                {item.overallRank}
              </Text>
            )}
            {index > 2 && (
              <Text
                style={{
                  width: '6%',
                  textAlign: 'center',
                  fontSize: 8,
                  fontWeight: 'bold',
                  padding: 2,
                }}
              >
                {item.overallRank}
              </Text>
            )}
            <Text
              style={{
                width: '6%',
                textAlign: 'center',
                fontSize: 8,
                padding: 2,
              }}
            >
              {item.zoneRank}
            </Text>
            <Text style={{ width: '20%', fontSize: 8, padding: 2 }}>
              {item.team}
            </Text>
            <Text style={{ width: '27%', fontSize: 8, padding: 2 }}>
              {item.sp}
            </Text>
            <Text
              style={{
                width: '5%',
                textAlign: 'center',
                fontSize: 8,
                padding: 2,
              }}
            >
              {item.zone}
            </Text>
            <Text
              style={{
                width: '5%',
                textAlign: 'center',
                fontSize: 8,
                padding: 2,
              }}
            >
              {item.sector}
            </Text>
            <Text
              style={{
                width: '5%',
                textAlign: 'center',
                fontSize: 8,
                padding: 2,
              }}
            >
              {item.fishCount}
            </Text>
            <Text
              style={{
                width: '7%',
                textAlign: 'center',
                fontSize: 8,
                padding: 2,
              }}
            >
              {item.totalWeight}
            </Text>
            <Text
              style={{
                width: '6%',
                textAlign: 'center',
                fontSize: 8,
                padding: 2,
              }}
            >
              {item.biggestFish}
            </Text>
            <Text
              style={{
                width: '6%',
                textAlign: 'center',
                fontSize: 8,
                padding: 2,
              }}
            >
              {item.averageWeight}
            </Text>
            <Text
              style={{
                width: '7%',
                textAlign: 'center',
                fontSize: 8,
                padding: 2,
              }}
            >
              {item.weightDifference}
            </Text>
          </View>
        </View>
      ))}
      <View style={{ borderWidth: 0.1, borderColor: '#fff', marginBottom: 0 }}>
        <View
          style={{
            flexDirection: 'row',
            backgroundColor: '#fff',
          }}
        >
          <Text
            style={{
              width: '6%',
              textAlign: 'center',
              fontSize: 8,
              fontWeight: 'bold',
              padding: 2,
            }}
          ></Text>
          <Text
            style={{
              width: '6%',
              textAlign: 'center',
              fontSize: 8,
              padding: 2,
            }}
          ></Text>
          <Text style={{ width: '23%', fontSize: 8, padding: 2 }}></Text>
          <Text
            style={{
              textAlign: 'right',
              width: '24%',
              fontSize: 8,
              padding: 2,
            }}
          >
            ВСЕГО
          </Text>
          <Text
            style={{
              width: '5%',
              textAlign: 'center',
              fontSize: 8,
              padding: 2,
            }}
          ></Text>
          <Text
            style={{
              width: '6%',
              textAlign: 'center',
              fontSize: 8,
              padding: 2,
            }}
          ></Text>
          <Text
            style={{
              width: '6%',
              textAlign: 'center',
              fontSize: 8,
              padding: 2,
            }}
          >
            {totalFishCount}
          </Text>
          <Text
            style={{
              width: '10%',
              textAlign: 'center',
              fontSize: 8,
              padding: 2,
            }}
          >
            {totalWeight}
          </Text>
          <Text
            style={{
              width: '6%',
              textAlign: 'center',
              fontSize: 8,
              padding: 2,
            }}
          ></Text>
          <Text
            style={{
              width: '6%',
              textAlign: 'center',
              fontSize: 8,
              padding: 2,
            }}
          >
            {averageFishWeight}
          </Text>
          <Text
            style={{
              width: '7%',
              textAlign: 'center',
              fontSize: 8,
              padding: 2,
            }}
          ></Text>
        </View>
      </View>
      {/* Биги */}
      <View
        style={{
          flexDirection: 'row',
          justifyContent: 'space-between',
          marginTop: 10,
        }}
      >
        <View
          style={{
            width: '50%',
          }}
        >
          <Text
            style={{
              fontSize: '8px',
            }}
          >
            Самая крупная рыба: {biggestFish.weight}
          </Text>
        </View>

        {/* <View
          style={{
            width: '50%',
          }}
        >
          <Text
            style={{
              fontSize: '8px',
            }}
          >
            Самая крупная рыба (1 суток): 14 870
          </Text>
          <Text
            style={{
              fontSize: '8px',
            }}
          >
            Самая крупная рыба (2 суток): 14 870
          </Text>
          <Text
            style={{
              fontSize: '8px',
            }}
          >
            Самая крупная рыба (3 суток): 14 870
          </Text>
        </View> */}
      </View>

      {/* Подписи */}
      <View
        style={{
          flexDirection: 'row',
          justifyContent: 'space-between',
          marginTop: 40,
        }}
      >
        <View
          style={{
            width: '35%',
            borderTopWidth: 1,
            borderTopStyle: 'solid',
            textAlign: 'center',
          }}
        >
          <Text
            style={{
              fontSize: '8px',
              textAlign: 'center',
            }}
          >
            {administrator[0]?.surname +
              ' ' +
              administrator[0]?.name +
              ' ' +
              administrator[0]?.patronymic +
              ' (' +
              administrator[0]?.role +
              ', ' +
              administrator[0]?.rank +
              ') '}
          </Text>
        </View>
        <View
          style={{
            width: '35%',
            borderTopWidth: 1,
            borderTopStyle: 'solid',
            textAlign: 'center',
          }}
        >
          <Text
            style={{
              fontSize: '8px',
              textAlign: 'center',
            }}
          >
            {administrator[1]?.surname +
              ' ' +
              administrator[1]?.name +
              ' ' +
              administrator[1]?.patronymic +
              ' (' +
              administrator[1]?.role +
              ', ' +
              administrator[1]?.rank +
              ') '}
          </Text>
        </View>
        <View
          style={{
            width: '20%',
            borderTopWidth: 1,
            borderTopStyle: 'solid',
            textAlign: 'center',
          }}
        >
          <Text
            style={{
              fontSize: '8px',
              textAlign: 'center',
            }}
          >
            Дата
          </Text>
        </View>
      </View>

      {/* Логотипы партнеров */}
      <View style={styles.logoContainer}>
        {allLogo.map((item, index) => (
          <Image key={index} src={item.url} style={styles.logoSmall} />
        ))}
      </View>
    </Page>
  </Document>
)

const ProtocolComSvod = ({ allLogo, mainLogo, data }) => {
  const [showPdfLink, setShowPdfLink] = useState(false)
  const [stage, setStage] = useState(null)
  const [totalFishCount, settotalFishCount] = useState(null)
  const [totalWeight, settotalWeight] = useState(null)
  const [averageFishWeight, setaverageFishWeight] = useState(null)
  const [biggestFish, setbiggestFish] = useState(null)
  const [isfinish, setfinish] = useState(null)
  const [tournament, setTournament] = useState(null)
  const [allLogos, setallLogot] = useState([])
  const [administrator, setaadministrator] = useState([])
  const { id } = useParams()
  useEffect(() => {
    const allgetData = async () => {
      //   console.log('data', data)

      const resultsU = await getData('teams', 'id', id)
      if (resultsU.length > 0) {
        const { key, value } = resultsU[0]
        const teamsArray = Object.values(value)
        const filteredTeams = teamsArray.filter((teamEntry) => {
          const isValidTeam =
            teamEntry !== null &&
            typeof teamEntry === 'object' &&
            teamEntry.team?.status === 'Заявка одобрена' &&
            teamEntry.team?.status_location === 1

          return isValidTeam
        })
        // setTeams(filteredTeams)

        const resultsS = await getData('stage', 'id', id)
        if (resultsS.length > 0) {
          const { key, value } = resultsS[0]

          const stageArray = Object.values(value)

          const filterestageArrays = stageArray.filter((teamEntry) => {
            const isValidTeam =
              teamEntry !== null && typeof teamEntry === 'object'

            return isValidTeam
          })

          const data = filterestageArrays
          const teamsInfo = filteredTeams

          // Обрабатываем данные команд
          const teams = {}
          teamsInfo.forEach((team) => {
            const sp1sports_category = team.athlete[0]?.sports_category
              ? ' (' + team.athlete[0]?.sports_category + ')'
              : ''
            const sp1 = team.athlete[0]?.fio ? team.athlete[0]?.fio : ''

            const sp2sports_category = team.athlete[1]?.sports_category
              ? ' (' + team.athlete[1]?.sports_category + ')'
              : ''
            const sp2 = team.athlete[1]?.fio ? ', ' + team.athlete[1]?.fio : ''

            const sp3sports_category = team.athlete[2]?.sports_category
              ? ' (' + team.athlete[2]?.sports_category + ')'
              : ''
            const sp3 = team.athlete[2]?.fio ? ', ' + team.athlete[2]?.fio : ''

            const name = getname(team.team) ? getname(team.team) : ''
            //     console.log('name', name)
            teams[team.team.id] = {
              id: team.team.id,
              team: name,
              zone: team.team.zona,
              sp:
                sp1 +
                sp1sports_category +
                sp2 +
                sp2sports_category +
                sp3 +
                sp3sports_category,
              sector: team.team.sector,
              totalWeight: 0,
              fishCount: 0,
              biggestFish: 0,
              averageWeight: 0,
              weightDifference: 0,
            }
          })

          //       console.log('teamsteamsteamsteams:', teams)
          console.log('data[0]:', data[0])
          // Подсчитываем уловы

          // Подсчитываем уловы
          data[0]?.forEach((entry) => {
            // console.log('entry', entry)
            if (entry.fishList && entry.fishList[0].weight === 0) return
            if (
              teams[entry.teamId] &&
              entry.fishList &&
              entry.fishList.length > 0
            ) {
              const weight = entry.fishList.reduce(
                (sum, fish) => sum + fish.weight,
                0
              )
              const biggestFish = Math.max(
                ...entry.fishList.map((fish) => fish.weight)
              )
              // teams[entry.teamId].sp = sp1
              if (entry.teamName && entry.teamName != '')
                teams[entry.teamId].team = entry.teamName
              teams[entry.teamId].totalWeight += weight
              teams[entry.teamId].fishCount += entry.fishList.length
              teams[entry.teamId].biggestFish = Math.max(
                teams[entry.teamId].biggestFish,
                biggestFish
              )
            } else {
              if (entry.teamName && entry.teamName != '')
                teams[entry.teamId].team = entry.teamName ?? entry.teamName
              //  teams[entry.teamId].sp = sp1
            }
          })

          // Вычисляем средний вес рыбы у каждой команды
          Object.values(teams).forEach((team) => {
            if (team.fishCount > 0) {
              team.averageWeight = Math.round(team.totalWeight / team.fishCount)
            }
          })
          //        console.log('data.forEach:', data)
          //        console.log('teams.forEach:', teams)
          // Группировка команд по зонам
          const zones = {}
          Object.values(teams).forEach((team) => {
            if (!zones[team.zone]) zones[team.zone] = []
            zones[team.zone].push(team)
          })
          // // Определение мест в зонах
          // Object.keys(zones).forEach((zone) => {
          //   zones[zone].sort(
          //     (a, b) =>
          //       b.totalWeight - a.totalWeight ||
          //       b.fishCount - a.fishCount  ||
          //       b.biggestFish - a.biggestFish
          //   )
          //   zones[zone].forEach((team, index) => (team.zoneRank = index + 1))
          // })

          // // Определение общего рейтинга
          // const allTeamsSorted = Object.values(teams).sort(
          //   (a, b) =>
          //     a.zoneRank - b.zoneRank ||
          //     b.totalWeight - a.totalWeight ||
          //     b.fishCount - a.fishCount ||
          //     b.biggestFish - a.biggestFish
          // )
          // allTeamsSorted.forEach(
          //   (team, index) => (team.overallRank = index + 1)
          // )
          // Определение мест в зонах
          // Object.keys(zones).forEach((zone) => {
          //   const teamsInZone = zones[zone]
          //   const totalTeamsInZone = teamsInZone.length // Общее количество команд в зоне

          //   // Разделяем команды на с рыбой и без
          //   const withFish = teamsInZone.filter((team) => team.totalWeight > 0)
          //   const withoutFish = teamsInZone.filter(
          //     (team) => team.totalWeight === 0
          //   )

          //   // Сортируем команды с рыбой по приоритетам:
          //   // 1. Вес (убывание)
          //   // 2. Количество рыбы (убывание)
          //   // 3. Крупная рыба (убывание)
          //   withFish.sort((a, b) => {
          //     if (b.totalWeight !== a.totalWeight)
          //       return b.totalWeight - a.totalWeight
          //     if (b.fishCount !== a.fishCount) return b.fishCount - a.fishCount
          //     return b.biggestFish - a.biggestFish
          //   })

          //   // Назначаем места командам с рыбой с учетом возможных ничьих
          //   let currentZoneRank = 1
          //   for (let i = 0; i < withFish.length; i++) {
          //     if (
          //       i > 0 &&
          //       (withFish[i].totalWeight !== withFish[i - 1].totalWeight ||
          //         withFish[i].fishCount !== withFish[i - 1].fishCount ||
          //         withFish[i].biggestFish !== withFish[i - 1].biggestFish)
          //     ) {
          //       currentZoneRank = i + 1
          //     }
          //     withFish[i].zoneRank = currentZoneRank
          //   }

          //   // ВСЕ команды без рыбы получают последнее место в зоне (равное общему числу команд)
          //   const lastZoneRank = totalTeamsInZone // Например, 8 для зоны из 8 команд

          //   withoutFish.forEach((team) => {
          //     team.zoneRank = lastZoneRank // Все получают zoneRank = 8
          //   })

          //   // Объединяем и обновляем зону
          //   zones[zone] = [...withFish, ...withoutFish]
          // })

          // Добавляем функцию для проверки ничьи между командами
          const isTie = (a, b) => {
            if (a.totalWeight !== b.totalWeight) return false

            const avgWeightA = a.fishCount > 0 ? a.totalWeight / a.fishCount : 0
            const avgWeightB = b.fishCount > 0 ? b.totalWeight / b.fishCount : 0
            if (avgWeightA !== avgWeightB) return false

            return a.biggestFish === b.biggestFish
          }

          Object.keys(zones).forEach((zone) => {
            const teamsInZone = zones[zone]
            const totalTeamsInZone = teamsInZone.length

            // Разделяем команды: с рыбой, без рыбы, снятые
            const withFish = teamsInZone.filter(
              (team) => team.totalWeight > 0 && !team.disqualified
            )
            const withoutFish = teamsInZone.filter(
              (team) => team.totalWeight === 0 && !team.disqualified
            )
            const disqualified = teamsInZone.filter((team) => team.disqualified)

            // Сортировка команд с рыбой по правилам:
            // 1. Вес (убывание), 2. Средний вес (возрастание), 3. Крупная рыба (убывание)
            withFish.sort((a, b) => {
              if (b.totalWeight !== a.totalWeight)
                return b.totalWeight - a.totalWeight

              const avgWeightA =
                a.fishCount > 0 ? a.totalWeight / a.fishCount : 0
              const avgWeightB =
                b.fishCount > 0 ? b.totalWeight / b.fishCount : 0
              if (avgWeightA !== avgWeightB) return avgWeightA - avgWeightB // Меньший средний вес выше

              return b.biggestFish - a.biggestFish
            })

            // Назначение мест с учетом ничьих
            let currentRank = 1
            for (let i = 0; i < withFish.length; i++) {
              if (i > 0) {
                const prev = withFish[i - 1]
                const curr = withFish[i]
                const isTie =
                  prev.totalWeight === curr.totalWeight &&
                  prev.totalWeight / prev.fishCount ===
                    curr.totalWeight / curr.fishCount &&
                  prev.biggestFish === curr.biggestFish
                if (!isTie) currentRank = i + 1
              }
              withFish[i].zoneRank = currentRank
            }

            // Команды без рыбы получают последнее место в зоне
            withoutFish.forEach((team) => {
              team.zoneRank = totalTeamsInZone
            })

            // Снятые команды получают место = totalTeamsInZone + 3
            disqualified.forEach((team) => {
              team.zoneRank = totalTeamsInZone + 3
            })

            zones[zone] = [...withFish, ...withoutFish, ...disqualified]
          })
          const allTeams = Object.values(teams)
          const teamsWithFish = allTeams.filter(
            (team) => team.totalWeight > 0 && !team.disqualified
          )
          const teamsWithoutFish = allTeams.filter(
            (team) => team.totalWeight === 0 && !team.disqualified
          )
          const disqualifiedTeams = allTeams.filter((team) => team.disqualified)
          // Сортируем команды с рыбой
          // Сортировка по зональному месту → весу → среднему весу → крупной рыбе
          teamsWithFish.sort((a, b) => {
            if (a.zoneRank !== b.zoneRank) return a.zoneRank - b.zoneRank
            if (b.totalWeight !== a.totalWeight)
              return b.totalWeight - a.totalWeight

            const avgWeightA = a.fishCount > 0 ? a.totalWeight / a.fishCount : 0
            const avgWeightB = b.fishCount > 0 ? b.totalWeight / b.fishCount : 0
            if (avgWeightA !== avgWeightB) return avgWeightA - avgWeightB

            return b.biggestFish - a.biggestFish
          })

          // Назначение общих мест
          let currentOverallRank = 1
          for (let i = 0; i < teamsWithFish.length; i++) {
            if (i > 0 && !isTie(teamsWithFish[i], teamsWithFish[i - 1])) {
              currentOverallRank = i + 1
            }
            teamsWithFish[i].overallRank = currentOverallRank
          }
          // Команды без рыбы и снятые
          const lastRank = allTeams.length
          teamsWithoutFish.forEach((team) => (team.overallRank = lastRank))
          disqualifiedTeams.forEach((team) => (team.overallRank = lastRank + 3))
          // Объединяем все команды
          const allTeamsSorted = [...teamsWithFish, ...teamsWithoutFish]

          // // Назначаем общие места
          // allTeamsSorted.forEach((team, index) => {
          //   // Все команды без рыбы получают максимальный (последний) номер места
          //   team.overallRank =
          //     team.totalWeight === 0 ? allTeamsSorted.length : index + 1
          // })

          // Определяем команду-лидера
          const leaderWeight =
            allTeamsSorted.length > 0 ? allTeamsSorted[0].totalWeight : 0

          // Вычисляем отставание от лидера
          Object.values(teams).forEach((team) => {
            team.weightDifference = leaderWeight - team.totalWeight
          })
          //       console.log('teams teams teams teams teams:', teams)
          // Поиск самой крупной рыбы
          const biggestFish = Object.values(teams).reduce(
            (max, team) =>
              team.biggestFish > max.weight
                ? { weight: team.biggestFish, team: team.name }
                : max,
            { weight: 0, team: '' }
          )

          // Общие данные по соревнованию
          const totalFishCount = Object.values(teams).reduce(
            (sum, team) => sum + team.fishCount,
            0
          )
          const totalWeight = Object.values(teams).reduce(
            (sum, team) => sum + team.totalWeight,
            0
          )
          const averageFishWeight =
            totalFishCount > 0 ? totalWeight / totalFishCount : 0

          // console.log('Результаты по зонам:', zones)
          // console.log('Общий рейтинг:', allTeamsSorted)
          // console.log('Самая крупная рыба:', biggestFish)
          // console.log('Общее количество пойманной рыбы:', totalFishCount)
          // console.log('Общий вес пойманной рыбы:', totalWeight)
          // console.log('Средний вес всех рыб:', Math.round(averageFishWeight))

          settotalFishCount(totalFishCount)
          settotalWeight(totalWeight)
          setaverageFishWeight(Math.round(averageFishWeight))
          setbiggestFish(biggestFish)
          setStage(allTeamsSorted)
        }
      }

      const resultsT = await getData('tournaments', 'id', id)
      if (resultsT.length > 0) {
        const { key, value } = resultsT[0]
        //  console.log(value)

        if (value.status_cup == 'Турнир завершен') setfinish(true)
        else setfinish(false)
        setTournament(value)
        const logosArray = Object.values(value.sponsor)
        //     console.log('logosArray', logosArray)
        setallLogot(logosArray)

        const logosadministrator = Object.values(value.administrator)
        //   console.log('logosadministrator', logosadministrator)
        setaadministrator(logosadministrator)
      }
    }
    if (showPdfLink) allgetData()
  }, [showPdfLink])
  const getname = (teamData) => {
    //    console.log('team_name_en', teamData.team_name_ru)
    return teamData?.preferred_name == 'en'
      ? teamData?.team_name_en
        ? teamData?.team_name_en
        : teamData?.team_name_ru
      : teamData?.team_name_ru
  }
  // if (showPdfLink) console.log('showPdfLink', showPdfLink)
  return (
    <div>
      {showPdfLink && stage && tournament ? (
        <PDFDownloadLink
          document={
            <TournamentProtocolPDF
              allLogo={allLogos}
              mainLogo={getLogoUrl(tournament?.logocup)}
              data={stage}
              administrator={administrator}
              tournament={tournament}
              date={dateNowProtocol(new Date())}
              totalFishCount={totalFishCount}
              totalWeight={totalWeight}
              averageFishWeight={averageFishWeight}
              biggestFish={biggestFish}
              isfinish={isfinish}
            />
          }
          fileName={'парный_протокол_' + dateNowProtocol(new Date()) + '.pdf'}
          onClick={() => {
            // Сразу после клика возвращаем в исходное состояние
            setTimeout(() => setShowPdfLink(false), 0)
          }}
        >
          {({ loading }) => (
            <button
              style={{
                padding: '10px 20px',
                backgroundColor: loading ? '#ccc' : '#4CAF50',
                color: 'white',
                border: 'none',
                borderRadius: '4px',
                cursor: 'pointer',
                fontSize: '16px',
              }}
              disabled={loading}
            >
              {loading ? 'Генерация PDF...' : 'Скачать '}
            </button>
          )}
        </PDFDownloadLink>
      ) : (
        <button
          onClick={() => setShowPdfLink(true)}
          style={{
            padding: '10px 20px',
            backgroundColor: '#4c7aaf',
            color: 'white',
            border: 'none',
            borderRadius: '4px',
            cursor: 'pointer',
            fontSize: '16px',
          }}
        >
          Парный протокол
        </button>
      )}
    </div>
  )
}

export default ProtocolComSvod
